import axios from 'axios'
import config from '@/f1/config'

function getApiHost() {
  switch(process.env.NODE_ENV) {
    case 'development' : return config.baseURL;
    default : return `${location.protocol}//${location.host.replace(/^[^\\.]*\./, 'api.')}/v1`;
  }
}
const baseUrl = getApiHost();
const http = axios.create({
  baseURL: baseUrl,
  timeout: 600000,

});

http.interceptors.request.use((request) => { if(request.data) { request.headers['Content-Type'] = 'application/json'; } return request; });
http.interceptors.response.use((response) => response.data, error => Promise.reject(error.response || { status: 500, data: error.message }));
if(location.hostname == 'localhost') { window['http'] = http; }

export default http
